// extracted by mini-css-extract-plugin
export default {"tooltip":"tW-z","arrow":"uW-z"};